import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class IsfListItem extends SearchModelBase {
    userId: string = '';
    status: string = '';
    disp: string = '';
    lastAction: string = '';
    isfNo: string = '';
    isfType: string = '';
    shipmentId: string = '';
    impName: string = '';
    impNo: string = '';
    mblNo: string = '';
    hblNo: string = '';
    tariffNo: string = '';
    branch: string = '';
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    isfDate: string | null = null;
    fromIsfDate: string | null = null;
    toIsfDate: string | null = null;
    bondHolder: string = '';
    createdBy: string = '';
    createDate: string | null = null;
    fromCreateDate: string | null = null;
    toCreateDate: string | null = null;
    modifiedBy: string = '';
    modifyDate: string | null = null;
    fromModifyDate: string | null = null;
    toModifyDate: string | null = null;
    id: number = 0;
    block: boolean|null = null;
    isfLinkIDs: string = '';
    isfStatus: string = '';
    cbpCode: string = '';
    cbpMsg: string = '';
    isAiAgent: boolean = false;
    ipAddress: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '+', width: 30, dataIndex: 'isAiAgent', hiddenInColumnSetup: true, type: XCol.XCellType.Bool, noNullOrEmptySearch: true}),
        XCol.Create({ col: 1, text: 'User ID', width: 80, dataIndex: 'userId'}),
        XCol.Create({ col: 2, text: 'Download', width:60, dataIndex: 'block', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 3, text: 'Status', width: 200, dataIndex: 'isfStatus'}),
        // XCol.Create({ col: 4, text: 'BR', width: 40, dataIndex: 'branch'}),
        XCol.Create({ col: 4, text: 'Disp', width: 60, dataIndex: 'disp'}),
        XCol.Create({ col: 5, text: 'CBP', width: 40, dataIndex: 'cbpCode', align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Last Action', width: 100, dataIndex: 'lastAction'}),
        XCol.Create({ col: 7, text: 'ISF #', width: 100, dataIndex: 'isfNo', defaultColumnFocus : true}),
        XCol.Create({ col: 8, text: 'ISF Type', width: 60, dataIndex: 'isfType', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 9, text: 'Shipment ID', width: 120, dataIndex: 'shipmentId'}),
        XCol.Create({ col: 10, text: 'Importer Name', width: 150, dataIndex: 'impName'}),
        XCol.Create({ col: 11, text: 'Importer #', width: 100, dataIndex: 'impNo'}),
        XCol.Create({ col: 12, text: 'MBL #', width: 100, dataIndex: 'mblNo'}),
        XCol.Create({ col: 13, text: 'HBL #', width: 100, dataIndex: 'hblNo'}),
        XCol.Create({ col: 14, text: 'HTS Code', width: 100, dataIndex: 'tariffNo'}),
        XCol.Create({ col: 15, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 16, text: 'ISF Due Date', width: 75, dataIndex: 'isfDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 17, text: 'Bond Holder', width: 150, dataIndex: 'bondHolder'}),
        XCol.Create({ col: 18, text: 'Create Date', width: 100, dataIndex: 'createDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 19, text: 'Create by', width: 100, dataIndex: 'createdBy'}), 
        XCol.Create({ col: 20, text: 'Update Date', width: 100, dataIndex: 'modifyDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 21, text: 'Update by', width: 100, dataIndex: 'modifiedBy'}),
        XCol.Create({ col: 22, text: 'IP Address', width: 110, dataIndex: 'ipAddress'}),
    ];


    public static getExportCollection(useBranch: boolean, isSuntekAdmin: boolean = false): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        if (!isSuntekAdmin) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'ipAddress');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: IsfListItem.prototype.id, orderByAscending: false };

    public static formatData(data: IsfListItem[]) {
        return data.map((d: IsfListItem) => ({
          ...d, isAiAgent: d.createdBy.toUpperCase() === '@AIAGENT' ? true : false
        }));
    }
    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        etd: {from: 'fromEtd', to: 'toEtd'},
        isfDate: {from: 'fromIsfDate', to: 'toIsfDate'},
        createDate: {from: 'fromCreateDate', to: 'toCreateDate'},
        modifyDate: {from: 'fromModifyDate', to: 'toModifyDate'},
    }
}
